import Vue from 'vue'
import App from './App'
import router from './router/lazy'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Viser from 'viser-vue'
import '@/icons' // icon
import axios from 'axios'
import store from './store'
import '@/permission'
import '@/permissions-list'
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.less'
import './import-component'
import ElementUI from 'element-ui'
import '@/utils/filter'
import '@/utils/dateUtil'
import echarts from 'echarts'
import {preDelete} from '@/mixins'
import { traceInitVue } from '@x-tech/fe-trace-sdk-web'
import * as packagejson from '../package.json'
import * as sentryPlugin from '@x-tech/fe-puma-lib-sentry-config/dist/vuePlugin'
Vue.use(sentryPlugin)
Vue.mixin(preDelete)
// import draggable from 'vuedraggable'
Vue.prototype.$echarts = echarts
// Vue.prototype.$draggable = draggable
// import VueBus from 'vue-bus'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
// Vue.use(VueBus)
Vue.use(Viser)
Vue.use(Antd)
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

traceInitVue('app', {
  productCode: 'rm-crm',
  productVersion: packagejson.version,
  env: window.XCConfig.VUE_APP_ENV
})



// WEBPACK FOOTER //
// ./src/main.js